import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d648113a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = {
  id: "home-carousel-container",
  style: {"height":"900px"}
}
const _hoisted_3 = {
  id: "home-carousel-background-img-container",
  class: "home-carousel-background-img-container",
  style: {"left":"0"}
}
const _hoisted_4 = { class: "home-carousel-item-container" }
const _hoisted_5 = { class: "home-carousel-item home-carousel-updown-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-title" }, [
  /*#__PURE__*/_createTextVNode("New Building "),
  /*#__PURE__*/_createElementVNode("br", { class: "home-carousel-item-title-br" }),
  /*#__PURE__*/_createTextVNode("Solutions")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-text" }, [
  /*#__PURE__*/_createTextVNode(" Infuse intelligence from the ground up with our smart technologies. We specialize in crafting "),
  /*#__PURE__*/_createElementVNode("br", { class: "home-carousel-item-text-br" }),
  /*#__PURE__*/_createTextVNode("tech-savvy spaces, guaranteeing your new building boasts the latest in software, hardware, and infrastructure for a modern and efficient environment. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-updown-top img-NewBuildingSolutions backImgStyle" }, null, -1))
const _hoisted_9 = { class: "home-carousel-item-container" }
const _hoisted_10 = { class: "home-carousel-item home-carousel-updown-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-title" }, [
  /*#__PURE__*/_createTextVNode("Existing Building "),
  /*#__PURE__*/_createElementVNode("br", { class: "home-carousel-item-title-br" }),
  /*#__PURE__*/_createTextVNode("Upgrades")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-text" }, [
  /*#__PURE__*/_createTextVNode(" Our solutions seamlessly integrate with your current setup, providing a cost-effective way to enhance efficiency, security, and connectivity. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Transform your existing building into a smart, responsive environment that meets the demands of contemporary living and working. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-updown-top img-ExistingBuildingUpgrades backImgStyle" }, null, -1))
const _hoisted_14 = { class: "home-carousel-item-container" }
const _hoisted_15 = { class: "home-carousel-item home-carousel-updown-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-title" }, "Infrastructure", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-item-text" }, [
  /*#__PURE__*/_createTextVNode(" We specialize in creating infrastructures that seamlessly integrate with your existing systems, maximizing efficiency while minimizing disruptions. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Whether upgrading or integrating new technologies, our solutions ensure a connected and agile environment. ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-updown-top img-Infrastructure backImgStyle" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-carousel-fill" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactUsButton = _resolveComponent("ContactUsButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass({
        'home-carousel': true,
        'event-none': _ctx.loading,
    }),
      id: "home-carousel",
      onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTouchStart && _ctx.handleTouchStart(...args))),
      onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleTouchEnd && _ctx.handleTouchEnd(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_ContactUsButton, {
                text: "Learn More",
                color: "blue",
                class: "home-carousel-item-contact",
                routeInfo: { path:'/buildingDevelopment' }
              })
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createVNode(_component_ContactUsButton, {
                text: "Learn More",
                color: "blue",
                class: "home-carousel-item-contact",
                routeInfo: { path:'/existingBuilding' }
              })
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createVNode(_component_ContactUsButton, {
                text: "Learn More",
                color: "blue",
                class: "home-carousel-item-contact",
                routeInfo: { path:'/infrastructure' }
              })
            ]),
            _hoisted_18
          ])
        ])
      ]),
      _hoisted_19
    ], 34)
  ], 64))
}